// as-cetra-ui/src/components/authenticated/handout/customise-mode/BlockToolbar.js

import React from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';

const BlockToolbar = ({ onEdit, onRemove, onAddBelow, isEditing }) => {
    return (
        <Box
            sx={{
                display: 'flex',
                gap: 0.5,
                alignItems: 'center',
                backgroundColor: 'rgba(0, 4, 83, 0.05)',
                borderRadius: 1,
                padding: '4px',
                mb: 1,
            }}
        >
            <Tooltip title={isEditing ? 'Editing...' : 'Edit this block'}>
                <span>
                    <IconButton
                        size="small"
                        onClick={onEdit}
                        disabled={isEditing}
                        sx={{
                            color: '#000453',
                            '&:hover': { backgroundColor: 'rgba(0, 4, 83, 0.1)' },
                        }}
                    >
                        <EditIcon fontSize="small" />
                    </IconButton>
                </span>
            </Tooltip>

            <Tooltip title="Remove this block">
                <IconButton
                    size="small"
                    onClick={onRemove}
                    sx={{
                        color: '#d32f2f',
                        '&:hover': { backgroundColor: 'rgba(211, 47, 47, 0.1)' },
                    }}
                >
                    <DeleteIcon fontSize="small" />
                </IconButton>
            </Tooltip>

            <Tooltip title="Add paragraph below">
                <IconButton
                    size="small"
                    onClick={onAddBelow}
                    sx={{
                        color: '#2e7d32',
                        '&:hover': { backgroundColor: 'rgba(46, 125, 50, 0.1)' },
                    }}
                >
                    <AddIcon fontSize="small" />
                </IconButton>
            </Tooltip>
        </Box>
    );
};

export default BlockToolbar;
